export default __webpack_public_path__ + "static/media/hub-32h.c1120567.svg";